<template lang="pug">
.order-container.fix
  div(v-if="!order.isDropshipping")
    img.logo(:src="`${imagePath}/others/print-return-${order.brand}.png`")
    .sender-info-container
      .sender-info.capitalize {{ data[order.brand].name  }} - {{ data[order.brand].documentNumber }}
      .sender-info.capitalize {{ data[order.brand].address }} - {{ data[order.brand].phone }}

  .container-zimple(v-else)
    img.logo-zimple(:src="`${imagePath}/others/logo-zimple.png`")
    .sender-info-container
      .sender-info Zimple Life SAS
      .sender-info 901.524.561-8
      .sender-info Calle 37B Sur #28c 01
      .sender-info 3245452675

  img.order-conveyor(v-if="order.conveyor && (order.conveyor !== 'sahet' && order.conveyor !== 'bassica')" :src="`${imagePath}/conveyors/${order.conveyor}.png`")
  .cod-delivery(v-if="(order.methodPay === 'dropshipping' || order.isWholesaler) && order.userPayConveyor") Envío al Cobro

  .order-total(v-if="order.methodPay === 'cod' || order.cod") Cobrar Paquete: {{ money(total) }}

  .order-info
    QRCode(:text="order.order" width="100")
    .order.uppercase {{ order.order }}
    .order-location.capitalize {{ buyerRemit.location }} - {{ buyerRemit.department }}
    .order-delivery-time {{ deliverySchedule[order.deliveryTime] }}

  .buyer-info
    .buyer-name.capitalize Nombre: {{ buyerRemit.name }}
    .buyer-phones Teléfonos: {{ buyerRemit.phones.join(', ') }}
    .buyer-address.uppercase Dirección: {{ buyerRemit.address }}
    .buyer-dni Cédula: {{ order.dni }}

    .order-observations
      ol.order-observation(v-for="(observation, index) in order.observations" v-if="observation.type === 'delivery'")
        li {{ observation.observation }}

  div(v-if="order.isDropshipping")
    .wait(v-if="!order.userPayConveyor || order.cod") Esperar Remite...
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import QRCode from '@/components/elements/QRCode'
import { getBuyerRemitFromOrder } from '@/helpers/remit'

export default {
  name: 'OrderPrintReturnAddress',

  mixins: [mForm, mFilters],

  components: { QRCode },

  props: {
    order: Object,
    remitOnly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      deliverySchedule: {
        '8-21': '🌞 8:00 a.m. - 🌚 9:00 p.m.',
        '8-20': '🌞 8:00 a.m. - 🌛 8:00 p.m.',
        '8-13': '🌞 8:00 a.m. - 😎 1:00 p.m.',
        '13-20': '😎 1:00 p.m. - 🌛 8:00 p.m.',
        '13-21': '😎 1:00 p.m. - 🌚 9:00 p.m.'
      }
    }
  },

  computed: {
    total () {
      return this.order.total || 0
    },

    data () {
      return this.$store.state.variables.data
    },

    quantitySale () {
      return 3
    },

    buyerRemit () {
      return getBuyerRemitFromOrder(this.order, { remitOnly: this.remitOnly })
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-container
  background-color white
  color black
  border .3mm dashed black
  width 7.1cm
  display inline-block
  padding 5mm
  vertical-align top

.logo
  height 6mm
  display block
  margin-bottom 1mm

.sender-info
  font-size 3.3mm
  font-weight 600

.buyer-info, .order-info
  margin-top 5mm

.order
  font-size 5mm
  font-weight 600

.order-conveyor
  height 6mm
  width auto
  margin-top 5mm
  filter brightness(0)

.order-location
  font-size 4mm
  font-weight 600

.order-delivery-time
  font-size 4mm

.order-total
  font-size 5mm
  margin-top 4mm
  font-weight 600
  text-decoration underline

.order-observations
  margin-top 4mm
  font-size 4mm
  list-style-type upper-alpha

.order-observation
  padding 0em 0 0em 1em

.order-observation > li
  list-style decimal

.buyer-name, .buyer-phones, .buyer-address, .buyer-dni
  font-size 4mm

.fix
  page-break-inside avoid

.cod-delivery
  font-size 5mm
  margin-top 4mm
  border 1mm solid black
  border-radius 2mm
  display inline-block
  padding 2mm
  font-weight 600

.wait
  font-size 4mm
  text-decoration underline
  font-weight 600

.container-zimple
  display flex
  gap 2mm
</style>



// WEBPACK FOOTER //
// src/components/pages/print/OrderPrintReturnAddressOld.vue